import { Helmet } from "react-helmet-async";
import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TablePagination,
} from "@mui/material";
// components

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import PickemDialog from "src/components/pickem-admin/PickemDialog";
// ----------------------------------------------------------------------

export default function GamePage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openCreatePickemDialog, setOpenCreatePickemDialog] = useState(false);
  const [rows, setRows] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/admin/pickems?offset=${
          page * rowsPerPage
        }&limit=${rowsPerPage}`
      )
      .then(function (response) {
        setRows(response.data.pickems);
        setLoading(false);
      });
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setOpenId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };

  const deleteGameHandler = () => {
    setLoading(true);
    setOpen(false);
    setOpenConfirm(false);
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/admin/game/${openId}/delete`)
      .then(function (response) {
        window.location.reload(false);
      });
  };
  const goToAppHandler = () => {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_USER_SERVICE_BASE_URL}/sso/nhl?appCode=${process.env.REACT_APP_USER_SERVICE_APP_CODE}&lang=en`
      )
      .then(function (response) {
        window.open(response.data.redirectUrl, "_blank");
        window.location.reload(false);
      });
  };
  const duplicatePickemHandler = () => {
    setLoading(true);
    setOpen(false);
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/pickems/${openId}/duplicate`
      )
      .then(function (response) {
        window.location.reload(false);
      });
  };

  // Create Pickem
  const createPickemHandler = (pickem) => {
    setLoading(true);
    setOpenCreatePickemDialog(false);
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/admin/pickems`, pickem)
      .then(function (response) {
        window.location.reload(false);
      });
  };

  const closeCreatePickemDialog = () => {
    setOpenCreatePickemDialog(false);
  };

  return (
    <>
      <Helmet>
        <title> Pickems </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Pickems
          </Typography>
          <Box>
            <Button
              variant="standard"
              startIcon={<Iconify icon="eva:paper-plane-outline" />}
              onClick={() => goToAppHandler()}
              sx={{ mr: 2 }}
            >
              Go To PrePlay
            </Button>
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={() => setOpenCreatePickemDialog(true)}
            >
              New Pickem
            </Button>
          </Box>
        </Stack>

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Title</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell align="center">Tenant</TableCell>
                      <TableCell>Start</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.title_en}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.status}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.tenants.join(", ")}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.start}
                        </TableCell>

                        <TableCell align="right">
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={handleOpenMenu}
                            id={row.pickem_id}
                          >
                            <Iconify icon={"eva:more-vertical-fill"} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
      <TablePagination
        sx={{ marginRight: "20px" }}
        rowsPerPageOptions={[10, 20]}
        component="div"
        count={-1}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem
          onClick={() =>
            navigate(`/dashboard/leaderboards/view?pickem_id=${openId}`)
          }
        >
          <Iconify icon={"eva:list-outline"} sx={{ mr: 1 }} />
          Leaderboard
        </MenuItem>
        <MenuItem onClick={() => duplicatePickemHandler()}>
          <Iconify icon={"eva:copy-outline"} sx={{ mr: 1 }} />
          Duplicate
        </MenuItem>
        <MenuItem
          onClick={() => navigate(`/dashboard/pickem/edit?pickem_id=${openId}`)}
        >
          <Iconify icon={"eva:edit-outline"} sx={{ mr: 1 }} />
          Edit
        </MenuItem>
      </Popover>
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to delete Game?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            All questions and cards would be deleted.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>
          <Button onClick={() => deleteGameHandler(true)} autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <PickemDialog
        open={openCreatePickemDialog}
        onSuccessHandler={createPickemHandler}
        onClose={closeCreatePickemDialog}
      />
    </>
  );
}
